<template>
    <div>
        <div class="nav flex flex-j-c">
            <div class="content  flex flex-a-c flex-j-c">
                <img src="../assets/img/logo.png" width="200" height="47" alt="">
                <div class="link" style="margin-left: 106px;" :class="{'active':active == '/pc-en/home'}"
                     @click="toPage('/pc-en/home')">Home
                </div>
                <div class="link" @mouseenter="productBoxHide" :class="{'active':active == '/pc-en/about-us'}"
                     @click="toPage('/pc-en/about-us')">About us
                </div>
                <div class="link position-r" @mouseenter="productBoxShow"
                     :class="{'active':active.indexOf('/product-center')  !== -1 }"
                     @click="toPage('/pc-en/product-center')"
                >Products
                    <div class="productBox" v-show="productBox" @mouseleave="productBoxHide">
                        <div v-for="item in productCate" :key="item.id" class="font-500"
                             @click.stop="toPage(`/pc-en/product-center?id=${item.id}&name=${item.name}`,1)">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <div class="link" @mouseenter="customizedServicesBoxShow"
                     :class="{'active':active == '/pc-en/customized-services'}"
                     @click="toPage('/pc-en/customized-services')">
                    Services
                </div>
                <div class="link position-r" @mouseenter="informationBoxShow"
                     @click="toPage('/pc-en/information-center/product-catalog')"
                     :class="{'active':active.indexOf('/pc-en/information-center')  !== -1 }">
                    Data
                    <div class="informationBox font-500" v-show="informationBox" @mouseleave="informationBoxHide">
                        <div @click.stop="toPage('/pc-en/information-center/product-catalog')">Product List</div>
                        <div @click.stop="toPage('/pc-en/information-center/common-problem')">FAQs</div>
                        <div @click.stop="toPage('/pc-en/information-center/literature')">Literature</div>
                    </div>
                </div>
                <div class="link" @mouseenter="informationBoxHide" :class="{'active':active == '/pc-en/contact-us'}"
                     @click="toPage('/pc-en/contact-us')">Contact
                </div>
                <div class="ml-50">
                    <!--                     @click="langChange(2)"-->
                    <span @click="langChange(1)">CHN</span>
                    <span class="ml-1">/</span>
                    <span class="color-red ml-1">ENG</span>
                </div>
            </div>

        </div>
        <div style="height: 100px;"></div>
    </div>
</template>

<script>
    export default {
        name: 'navHeader',
        props: {},
        data() {
            return {
                active: '/pc-en/home',
                productBox: false,
                informationBox: false,
                productCate: [],
            }
        },
        mounted() {
            this.getProductCate()
            if (sessionStorage.getItem('navActive')) this.active = sessionStorage.getItem('navActive')
        },
        methods: {
            async getProductCate() {
                console.log(1231213)
                this.productCate = await this.$api.getProductCate()
                console.log(123, this.productCate)
            },

            langChange(type) {
                this.$router.push('/pc/home')
                /*if (this.$route.fullPath.indexOf('-en') === -1 && type == 2) {
                    let arr = this.$route.fullPath.split('/pc')
                    let path = arr[0] + '/pc-en' + arr[1]
                    this.$router.push(path)
                } else if (this.$route.fullPath.indexOf('-en') !== -1 && type == 1) {
                    let arr = this.$route.fullPath.split('-en')
                    let path = arr[0] + arr[1]
                    this.$router.push(path)
                }*/
            },
            toPage(src, flag) {
                this.active = src
                sessionStorage.setItem('navActive', this.active)
                if (flag) {
                    window.location.href = src
                } else {
                    this.$router.push(src)
                }
            },
            productBoxShow() {
                console.log(1)
                this.productBox = true
                this.informationBox = false
            },
            productBoxHide() {
                console.log(2)
                this.productBox = false
            },
            informationBoxShow() {
                this.informationBox = true
                this.productBox = false
            },
            informationBoxHide() {
                this.informationBox = false
            },
            customizedServicesBoxShow() {
                this.informationBox = false
                this.productBox = false
            },
            boxHide() {
                this.informationBox = false
                this.productBox = false
            }
        }
    }
</script>
<style scoped lang="scss">
    .nav {
        height: 100px;
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        background-color: #fff;
        font-size: 18px;

        .content {
            height: 100px;
            width: 1200px;

            .link {
                padding: 2px 10px;
                margin-left: 20px;
                height: 100px;
                line-height: 100px;
            }

            .active {
                color: $red;
                position: relative;
                font-weight: 600;
            }

            .active::after {
                content: '';
                height: 4px;
                width: 100%;
                border-radius: 2px;
                position: absolute;
                background-color: $red;
                left: 0;
                bottom: 20px;
            }

            .productBox {
                position: absolute;
                left: -542px;
                z-index: 100;
                top: 100px;
                display: flex;
                flex-wrap: wrap;
                width: 1200px;
                background: #FFFFFF;
                box-shadow: 0px 0px 10px 0px rgba(178, 196, 205, 1);
                border-radius: 1px;
                padding: 30px 40px;
                color: #333;

                div:hover {
                    color: $red;
                    cursor: pointer;
                }

                div {
                    flex: 0 0 25%;
                    padding: 20px;
                    line-height: 40px;

                }
            }

            .informationBox {
                position: absolute;
                left: -136px;
                top: 100px;
                z-index: 100;
                width: 372px;
                height: 280px;
                background: #FFFFFF;
                box-shadow: 0px 0px 10px 0px #B2C4CD;
                border-radius: 1px;
                color: #333;
                padding: 20px 0;

                div {
                    padding: 20px 0;
                    line-height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }

                div:hover {
                    color: $red;
                }
            }
        }


    }


</style>
